import { render, staticRenderFns } from "./abroad-competitor.vue?vue&type=template&id=fc47a400&scoped=true&"
import script from "./abroad-competitor.vue?vue&type=script&lang=js&"
export * from "./abroad-competitor.vue?vue&type=script&lang=js&"
import style0 from "./abroad-competitor.vue?vue&type=style&index=0&id=fc47a400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc47a400",
  null
  
)

export default component.exports